var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWingsGold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 18,
    viewBox: "0 0 36 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.02819 12.6261C11.3035 12.92 13.2885 13.844 14.6941 15.117C14.9884 15.3836 14.8788 16.2323 14.5264 16.4154C12.8436 17.2896 10.689 17.679 8.41365 17.3852C6.13832 17.0914 4.15329 16.1674 2.74778 14.8944C2.45341 14.6278 2.56306 13.779 2.91545 13.5959C4.5982 12.7217 6.75286 12.3323 9.02819 12.6261Z",
    fill: "url(#paint0_linear_21927_171309)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.02819 12.6261C11.3035 12.92 13.2885 13.844 14.6941 15.117C14.9884 15.3836 14.8788 16.2323 14.5264 16.4154C12.8436 17.2896 10.689 17.679 8.41365 17.3852C6.13832 17.0914 4.15329 16.1674 2.74778 14.8944C2.45341 14.6278 2.56306 13.779 2.91545 13.5959C4.5982 12.7217 6.75286 12.3323 9.02819 12.6261Z",
    fill: "url(#paint1_linear_21927_171309)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29165 9.4394C11.725 10.4943 13.634 12.1565 14.7877 14.0205C15.0292 14.4108 14.6357 15.3185 14.1856 15.4091C12.0366 15.8413 9.51841 15.5839 7.08514 14.529C4.65181 13.4741 2.74276 11.812 1.58914 9.94792C1.34759 9.55757 1.74111 8.64987 2.19115 8.55932C4.34023 8.12716 6.85831 8.38448 9.29165 9.4394Z",
    fill: "url(#paint2_linear_21927_171309)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29165 9.4394C11.725 10.4943 13.634 12.1565 14.7877 14.0205C15.0292 14.4108 14.6357 15.3185 14.1856 15.4091C12.0366 15.8413 9.51841 15.5839 7.08514 14.529C4.65181 13.4741 2.74276 11.812 1.58914 9.94792C1.34759 9.55757 1.74111 8.64987 2.19115 8.55932C4.34023 8.12716 6.85831 8.38448 9.29165 9.4394Z",
    fill: "url(#paint3_linear_21927_171309)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8922 12.6261C24.6168 12.92 22.6318 13.844 21.2263 15.117C20.9319 15.3836 21.0416 16.2323 21.394 16.4154C23.0767 17.2896 25.2314 17.679 27.5067 17.3852C29.782 17.0914 31.7671 16.1674 33.1726 14.8944C33.4669 14.6278 33.3573 13.779 33.0049 13.5959C31.3222 12.7217 29.1675 12.3323 26.8922 12.6261Z",
    fill: "url(#paint4_linear_21927_171309)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8922 12.6261C24.6168 12.92 22.6318 13.844 21.2263 15.117C20.9319 15.3836 21.0416 16.2323 21.394 16.4154C23.0767 17.2896 25.2314 17.679 27.5067 17.3852C29.782 17.0914 31.7671 16.1674 33.1726 14.8944C33.4669 14.6278 33.3573 13.779 33.0049 13.5959C31.3222 12.7217 29.1675 12.3323 26.8922 12.6261Z",
    fill: "url(#paint5_linear_21927_171309)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6262 9.4394C24.1928 10.4943 22.2838 12.1565 21.1302 14.0205C20.8886 14.4108 21.2821 15.3185 21.7322 15.4091C23.8812 15.8413 26.3994 15.5839 28.8327 14.529C31.266 13.4741 33.175 11.812 34.3287 9.94792C34.5702 9.55757 34.1767 8.64987 33.7267 8.55932C31.5776 8.12716 29.0595 8.38448 26.6262 9.4394Z",
    fill: "url(#paint6_linear_21927_171309)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6262 9.4394C24.1928 10.4943 22.2838 12.1565 21.1302 14.0205C20.8886 14.4108 21.2821 15.3185 21.7322 15.4091C23.8812 15.8413 26.3994 15.5839 28.8327 14.529C31.266 13.4741 33.175 11.812 34.3287 9.94792C34.5702 9.55757 34.1767 8.64987 33.7267 8.55932C31.5776 8.12716 29.0595 8.38448 26.6262 9.4394Z",
    fill: "url(#paint7_linear_21927_171309)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1221 4.4161C12.6032 6.64668 14.2165 9.39211 14.8477 12.0766C14.98 12.6388 14.1479 13.5643 13.5748 13.4925C10.8385 13.1494 7.93756 11.8364 5.45646 9.60574C2.97535 7.37516 1.36211 4.62972 0.730813 1.94526C0.598608 1.38308 1.4307 0.4575 2.00374 0.529337C4.73997 0.872451 7.641 2.18552 10.1221 4.4161Z",
    fill: "url(#paint8_linear_21927_171309)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1221 4.4161C12.6032 6.64668 14.2165 9.39211 14.8477 12.0766C14.98 12.6388 14.1479 13.5643 13.5748 13.4925C10.8385 13.1494 7.93756 11.8364 5.45646 9.60574C2.97535 7.37516 1.36211 4.62972 0.730813 1.94526C0.598608 1.38308 1.4307 0.4575 2.00374 0.529337C4.73997 0.872451 7.641 2.18552 10.1221 4.4161Z",
    fill: "url(#paint9_linear_21927_171309)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7963 4.4161C23.3152 6.64668 21.7019 9.39211 21.0707 12.0766C20.9385 12.6388 21.7705 13.5643 22.3436 13.4925C25.0799 13.1494 27.9808 11.8364 30.4619 9.60574C32.9431 7.37516 34.5563 4.62972 35.1876 1.94526C35.3198 1.38308 34.4877 0.4575 33.9147 0.529337C31.1784 0.872451 28.2774 2.18552 25.7963 4.4161Z",
    fill: "url(#paint10_linear_21927_171309)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7963 4.4161C23.3152 6.64668 21.7019 9.39211 21.0707 12.0766C20.9385 12.6388 21.7705 13.5643 22.3436 13.4925C25.0799 13.1494 27.9808 11.8364 30.4619 9.60574C32.9431 7.37516 34.5563 4.62972 35.1876 1.94526C35.3198 1.38308 34.4877 0.4575 33.9147 0.529337C31.1784 0.872451 28.2774 2.18552 25.7963 4.4161Z",
    fill: "url(#paint11_linear_21927_171309)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21927_171309",
    x1: 6.20616,
    y1: 11.5384,
    x2: 8.69632,
    y2: 14.9718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_21927_171309",
    x1: 8.72092,
    y1: 14.0186,
    x2: 8.72092,
    y2: 17.2321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_21927_171309",
    x1: 3.6494,
    y1: 8.61123,
    x2: 7.76194,
    y2: 11.6673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_21927_171309",
    x1: 8.1884,
    y1: 10.5393,
    x2: 8.1884,
    y2: 15.2432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_21927_171309",
    x1: 29.7141,
    y1: 11.5384,
    x2: 27.224,
    y2: 14.9718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_21927_171309",
    x1: 27.1994,
    y1: 14.0186,
    x2: 27.1994,
    y2: 17.2321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_21927_171309",
    x1: 32.2684,
    y1: 8.61123,
    x2: 28.1559,
    y2: 11.6673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_21927_171309",
    x1: 27.7294,
    y1: 10.5393,
    x2: 27.7294,
    y2: 15.2432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_21927_171309",
    x1: 6.38589,
    y1: 2.62205,
    x2: 8.46102,
    y2: 9.11156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_21927_171309",
    x1: 7.78928,
    y1: 4.42577,
    x2: 7.78928,
    y2: 12.8419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_21927_171309",
    x1: 29.5325,
    y1: 2.62205,
    x2: 27.4574,
    y2: 9.11156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEF0AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBC56D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_21927_171309",
    x1: 28.1291,
    y1: 4.42577,
    x2: 28.1291,
    y2: 12.8419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC8758",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#DC8758",
    stopOpacity: 0.996
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC8758"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWingsGold);
export default __webpack_public_path__ + "static/media/wings_gold.88bca6e8894f5c11107eb55f749ca43b.svg";
export { ForwardRef as ReactComponent };